/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { User } from '../models/user';
import { UserCredentials } from '../models/user-credentials';
import { UserPreference } from '../models/user-preference';
@Injectable({
  providedIn: 'root',
})
class AccountService extends __BaseService {
  static readonly AccountLoginPath = '/api/account/login';
  static readonly AccountForgotUserPasswordPath = '/api/account/{username}/password/forgot';
  static readonly AccountValidateResetPasswordPath = '/api/account/{username}/password/reset/validate';
  static readonly AccountResetForgottenPasswordPath = '/api/account/password/forgot/reset';
  static readonly AccountResetUserPasswordPath = '/api/account/password/reset';
  static readonly AccountImpersonateUserPath = '/api/account/impersonate';
  static readonly AccountUpdateUserPreferencesPath = '/api/account/user/preferences';
  static readonly AccountRefreshTokenPath = '/api/account/token/refresh';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param userCredentials undefined
   * @return OK
   */
  AccountLoginResponse(userCredentials: UserCredentials): __Observable<__StrictHttpResponse<User>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = userCredentials;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/account/login`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<User>;
      })
    );
  }
  /**
   * @param userCredentials undefined
   * @return OK
   */
  AccountLogin(userCredentials: UserCredentials): __Observable<User> {
    return this.AccountLoginResponse(userCredentials).pipe(
      __map(_r => _r.body as User)
    );
  }

  /**
   * @param username undefined
   * @return OK
   */
  AccountForgotUserPasswordResponse(username: string): __Observable<__StrictHttpResponse<{}>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/account/${encodeURIComponent(username)}/password/forgot`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<{}>;
      })
    );
  }
  /**
   * @param username undefined
   * @return OK
   */
  AccountForgotUserPassword(username: string): __Observable<{}> {
    return this.AccountForgotUserPasswordResponse(username).pipe(
      __map(_r => _r.body as {})
    );
  }

  /**
   * @param params The `AccountService.AccountValidateResetPasswordParams` containing the following parameters:
   *
   * - `username`:
   *
   * - `code`:
   *
   * @return OK
   */
  AccountValidateResetPasswordResponse(params: AccountService.AccountValidateResetPasswordParams): __Observable<__StrictHttpResponse<{}>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.code != null) __params = __params.set('code', params.code.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/account/${encodeURIComponent(params.username)}/password/reset/validate`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<{}>;
      })
    );
  }
  /**
   * @param params The `AccountService.AccountValidateResetPasswordParams` containing the following parameters:
   *
   * - `username`:
   *
   * - `code`:
   *
   * @return OK
   */
  AccountValidateResetPassword(params: AccountService.AccountValidateResetPasswordParams): __Observable<{}> {
    return this.AccountValidateResetPasswordResponse(params).pipe(
      __map(_r => _r.body as {})
    );
  }

  /**
   * @param params The `AccountService.AccountResetForgottenPasswordParams` containing the following parameters:
   *
   * - `user`:
   *
   * - `code`:
   *
   * @return OK
   */
  AccountResetForgottenPasswordResponse(params: AccountService.AccountResetForgottenPasswordParams): __Observable<__StrictHttpResponse<{}>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.user;
    if (params.code != null) __params = __params.set('code', params.code.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/account/password/forgot/reset`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<{}>;
      })
    );
  }
  /**
   * @param params The `AccountService.AccountResetForgottenPasswordParams` containing the following parameters:
   *
   * - `user`:
   *
   * - `code`:
   *
   * @return OK
   */
  AccountResetForgottenPassword(params: AccountService.AccountResetForgottenPasswordParams): __Observable<{}> {
    return this.AccountResetForgottenPasswordResponse(params).pipe(
      __map(_r => _r.body as {})
    );
  }

  /**
   * @param user undefined
   * @return OK
   */
  AccountResetUserPasswordResponse(user: UserCredentials): __Observable<__StrictHttpResponse<{}>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = user;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/account/password/reset`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<{}>;
      })
    );
  }
  /**
   * @param user undefined
   * @return OK
   */
  AccountResetUserPassword(user: UserCredentials): __Observable<{}> {
    return this.AccountResetUserPasswordResponse(user).pipe(
      __map(_r => _r.body as {})
    );
  }

  /**
   * @param params The `AccountService.AccountImpersonateUserParams` containing the following parameters:
   *
   * - `password`:
   *
   * - `impersonateUser`:
   *
   * @return OK
   */
  AccountImpersonateUserResponse(params: AccountService.AccountImpersonateUserParams): __Observable<__StrictHttpResponse<{}>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.password != null) __params = __params.set('password', params.password.toString());
    if (params.impersonateUser != null) __params = __params.set('impersonateUser', params.impersonateUser.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/account/impersonate`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<{}>;
      })
    );
  }
  /**
   * @param params The `AccountService.AccountImpersonateUserParams` containing the following parameters:
   *
   * - `password`:
   *
   * - `impersonateUser`:
   *
   * @return OK
   */
  AccountImpersonateUser(params: AccountService.AccountImpersonateUserParams): __Observable<{}> {
    return this.AccountImpersonateUserResponse(params).pipe(
      __map(_r => _r.body as {})
    );
  }

  /**
   * @param preferences undefined
   * @return OK
   */
  AccountUpdateUserPreferencesResponse(preferences: Array<UserPreference>): __Observable<__StrictHttpResponse<{}>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = preferences;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/account/user/preferences`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<{}>;
      })
    );
  }
  /**
   * @param preferences undefined
   * @return OK
   */
  AccountUpdateUserPreferences(preferences: Array<UserPreference>): __Observable<{}> {
    return this.AccountUpdateUserPreferencesResponse(preferences).pipe(
      __map(_r => _r.body as {})
    );
  }

  /**
   * @param user undefined
   * @return OK
   */
  AccountRefreshTokenResponse(user: User): __Observable<__StrictHttpResponse<User>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = user;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/account/token/refresh`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<User>;
      })
    );
  }
  /**
   * @param user undefined
   * @return OK
   */
  AccountRefreshToken(user: User): __Observable<User> {
    return this.AccountRefreshTokenResponse(user).pipe(
      __map(_r => _r.body as User)
    );
  }
}

module AccountService {

  /**
   * Parameters for AccountValidateResetPassword
   */
  export interface AccountValidateResetPasswordParams {
    username: string;
    code: string;
  }

  /**
   * Parameters for AccountResetForgottenPassword
   */
  export interface AccountResetForgottenPasswordParams {
    user: UserCredentials;
    code: string;
  }

  /**
   * Parameters for AccountImpersonateUser
   */
  export interface AccountImpersonateUserParams {
    password: string;
    impersonateUser: string;
  }
}

export { AccountService }
